module.exports = __webpack_public_path__ + "static/media/logo_mapbiomas_ecuador.dadcd3ff.png";